import type { IReplicaPageMetadata, IReplicaPageMetadataArticle } from '@pressreader/content-types';

import type { IIssuePageMetadataArticleDto, IIssuePageMetadataDto } from '../types';

function mapIssuePageMetadataArticle(dto: IIssuePageMetadataArticleDto): IReplicaPageMetadataArticle {
    return {
        regionId: dto.RegionId,
        articleId: String(dto.ArticleId),
        primaryArticleId: String(dto.RootArticleId),
        hateIt: dto.HateIt,
        likeIt: dto.LikeIt,
        comments: dto.Comments,
    };
}

function mapIssuePageMetadata(dto: IIssuePageMetadataDto): IReplicaPageMetadata {
    return {
        pageNumber: dto.PageNumber,
        articles: (dto.Articles || []).map(mapIssuePageMetadataArticle),
    };
}

export { mapIssuePageMetadata };
